import client from './http';

export default {
  async signup({ firstName, lastName, email, enableMarketingEmails }) {
    const response = await client.post('/api/signup-saving-auth/signup', { firstName, lastName, email, enableMarketingEmails });
    return response.data;
  },

  async signupMember() {
    const response = await client.post('/api/signup-saving-auth/signup-member', {});
    return response.data;
  },

  async getSaverDetails() {
    const response = await client.get('/api/saving/saver/');
    return response.data;
  },
};
